import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

interface SlotSelectionModeToggleProps {
  value: "calendly" | "manual";
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function SlotSelectionModeToggle({
  value,
  onChange,
}: SlotSelectionModeToggleProps) {
  return (
    <FormControl>
      <FormLabel id="slot-selection-mode-label">
        <Typography color="black" fontWeight={600} variant="body2">
          Select how you want to provide your availability times
        </Typography>
      </FormLabel>
      <RadioGroup
        aria-labelledby="slot-selection-mode-label"
        name="slot-selection-mode"
        row
        value={value}
        onChange={onChange}
      >
        <FormControlLabel value="calendly" control={<Radio />} label="Calendly" />
        <FormControlLabel
          value="manual"
          control={<Radio />}
          label="Manual selection"
        />
      </RadioGroup>
    </FormControl>
  );
}


